<template>
  <div class="fy-head__menu" :class="{'fy-head__menu_show':isShowMenu}">
        <img :src="MenuClose" class="fy-head__menu__close" @click="onClose"/>
        <div class="fy-head__menu__item" v-for="item in menuList" :key="item.name">
          <div @click="goOther(item.url)" class="fy-head__menu__item__link">
            <div class="fy-head__menu__item__link_name">{{item.name}}</div>
            <div class="fy-head__menu__item__link_nameZh">{{item.nameZh}}</div>
          </div>
        </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {DrawerLayout} from 'vue-drawer-layout'
import menuBottom from '@/assets/home-logo.png'
import MenuClose from "@/assets/close.png"
Vue.component(DrawerLayout.name, DrawerLayout)
export default Vue.extend({
  props:{
    isShowMenu:{
      type:Boolean,
      default:false
    },
    onClose: {
      type: Function,
      default: () => {}
    }
  },
  name:'top-head',
  data () {
    return {
      menuBottom,
      MenuClose,
      menuList: [
        {
          name: "品牌介绍",
          nameZh: "ABOUT US",
          url: "/brand",
        },
        {
          name: "产品系列",
          nameZh: "SERIES PRODUCTS",
          url: "/products",
        },
        {
          name: "品牌合作",
          nameZh: "COLLABORATION",
          url: "/brand_cooperate",
        },
        {
          name: "联系我们",
          nameZh: "CONTACT US",
          url: "/contact_us",
        },
        {
          name: "加入我们",
          nameZh: "JOIN US",
          url: "/join_us",
        },
      ],
    }
  },
  methods:{
    goOther(url){
      if(url===this.$route.path){
        this.$router.go(0)
      }else{
        this.$router.push(url)
      }
    }
  }
})
</script>
